import { DEFAULT_THEME, DEFAULT_MODE, PRO_MODE } from './constants';

/**
 * Derives the mode based on context and user data.
 * @param {Context} options.context The current request's context.
 * @param {User} options.user The current user's data.
 * @return {String}
 */
export const getMode = ({ user, context }) => {
    const isProMode = !user.business && context.isPro;
    return isProMode ? PRO_MODE : DEFAULT_MODE;
};

/**
 * Serializes the layout data into a format accepted by the categories menu package.
 * @param {Context} context - The current request context.
 * @param {NavigationMenu} navigationMenu - The current navigation menu to use.
 * @return {Object}
 */
export const serializer = ({ context, navigationMenu, user }) => ({
    useCmsConfig: true,
    shouldPreRender: context.knownCrawler,
    theme: DEFAULT_THEME,
    locale: context.locale,
    config: navigationMenu.config,
    mode: getMode({ user, context })
});

export { default } from '@fiverr-private/categories_menu/src';
